import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import SubaccountsList from 'subaccounts/components/list';
import { createRoute } from 'lib/util';

const { Form } = Common;

const SubaccountsListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  subcompany = {},
  handleToggle = () => {},
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  columnSearch,
  handleToggleSearch = () => {}, // Agregar
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      {/* <SubaccountsList.Header
        companyId={company.id}
        subcompanyId={subcompany.id}
        canAdd={permissions["acl.accounts.add"]}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('menu.configuration') + ' > ' + t('subaccounts.subaccounts_title')}
          icon={'archive'}
          button={
            <div className="btn-group pull-right">
              {permissions['acl.accounts.add'] && (
                <Form.Link
                  to={createRoute(company.id, subcompany.id, 'subaccounts/add')}
                  className="btn btn-info"
                >
                  {t('actions.add')}
                </Form.Link>
              )}
            </div>
          }
          buttonTwo={
            <SubaccountsList.Filters
              handleSubmit={handleSubmit}
              handleToggleSearch={handleToggleSearch} // Agregar
              columnSearch={columnSearch} // Agregar
              handleValueChange={handleFiltersChange}
              values={filters}
            />
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <SubaccountsList.Table
              company={company}
              subcompany={subcompany}
              permissions={permissions}
              handleToggle={handleToggle}
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </SubaccountsList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(SubaccountsListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/SubaccountsListView.js